import { ActionIcon } from "PFComponents/action_icon";
import Tooltip from "PFComponents/tooltip/tooltip";
import React from "react";

import css from "../dates.module.scss";

type DayToggleButtonProps = {
  isDisabled: boolean;
  onToggle: () => void;
  tooltipMessage?: string;
};

export const DayToggleButton = ({
  isDisabled,
  onToggle,
  tooltipMessage
}: DayToggleButtonProps): JSX.Element => (
  <Tooltip content={tooltipMessage && <span>{tooltipMessage}</span>}>
    <div style={{ opacity: isDisabled ? "0.4" : "1" }}>
      <ActionIcon name="department" size="md" classes={{ root: css.dayToggle }} onClick={onToggle} />
    </div>
  </Tooltip>
);
